import { Link, useRouterState } from "@tanstack/react-router";
import { Home, Camera, Images, FileSignature, Receipt, User, Aperture } from "lucide-react";
import {
  Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent,
  SidebarGroupLabel, SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem,
} from "@/components/ui/sidebar";
import { organizations } from "@/mocks/saas-data";
import { useMockAuth } from "@/lib/mock-auth";

const items = [
  { title: "Home", url: "/portal", icon: Home, exact: true },
  { title: "Shoots", url: "/portal/shoots", icon: Camera },
  { title: "Galleries", url: "/portal/galleries", icon: Images },
  { title: "Contracts", url: "/portal/contracts", icon: FileSignature },
  { title: "Invoices", url: "/portal/invoices", icon: Receipt },
  { title: "Profile", url: "/portal/profile", icon: User },
];

export function PortalSidebar() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const { session } = useMockAuth();
  const org = organizations.find((o) => o.id === session?.orgId) ?? organizations[0];

  return (
    <Sidebar collapsible="icon" className="border-r border-border">
      <SidebarHeader className="p-4">
        <Link to="/portal" className="flex items-center gap-3 px-2 py-1">
          <div
            className="flex size-8 flex-none items-center justify-center rounded-md text-background"
            style={{ background: `oklch(0.45 0.12 ${org.brandHue})` }}
          >
            <Aperture className="size-4" />
          </div>
          <div className="flex flex-col leading-tight group-data-[collapsible=icon]:hidden">
            <span className="text-sm font-semibold tracking-tight">{org.name}</span>
            <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
              Client Portal
            </span>
          </div>
        </Link>
      </SidebarHeader>
      <SidebarContent className="px-2">
        <SidebarGroup>
          <SidebarGroupLabel className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground/70">
            Your Account
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {items.map((item) => {
                const active = item.exact ? pathname === item.url : pathname.startsWith(item.url);
                return (
                  <SidebarMenuItem key={item.url}>
                    <SidebarMenuButton asChild isActive={active}>
                      <Link to={item.url} className="flex items-center gap-2">
                        <item.icon className="size-4" />
                        <span className="font-medium">{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
